module.exports = __webpack_public_path__ + "static/ebapp-1-2f856a089f7003ad0870d6f7f09a3589.jpg";